import { render, staticRenderFns } from "./process10.vue?vue&type=template&id=33c861f7&scoped=true&"
import script from "./process10.vue?vue&type=script&lang=js&"
export * from "./process10.vue?vue&type=script&lang=js&"
import style0 from "./process10.vue?vue&type=style&index=0&id=33c861f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c861f7",
  null
  
)

export default component.exports